import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import * as models from 'app/models';
import * as viewmodels from 'app/viewmodels';
import * as services from 'app/services';

@Component({
    selector: 'app-task-type-select-multiple-btn',
    templateUrl: './task-type-select-multiple-btn.component.html',
    styleUrls: ['./task-type-select-multiple-btn.component.scss'],
    standalone: false
})
export class TaskTypeSelectMultipleBtnComponent implements OnInit {

  templatedTaskItems: viewmodels.MultiSelect[] = [];

  selectedValue: Array<string>;
  @Input()
  get selected() {
    return this.selectedValue;
  }
  @Output() selectedChange = new EventEmitter();
  set selected(val) {
    if(val == null){
      val = [];
    }
    this.selectedValue = val;
    this.selectedChange.emit(this.selectedValue);

    this.selectedTaskTypes = this.templatedTaskItems.filter(i => this.selected.includes(i.id));
  }
  @Output() onClosed = new EventEmitter();

  selectedTaskTypesValue: Array<viewmodels.MultiSelect>;
  @Input()
  get selectedTaskTypes() {
    return this.selectedTaskTypesValue;
  }
  @Output() selectedTaskTypesChange = new EventEmitter();
  set selectedTaskTypes(val) {
    if (val == null) {
      val = [];
    }
    this.selectedTaskTypesValue = val;
    this.selectedTaskTypesChange.emit(this.selectedTaskTypesValue);
  }

  constructor(
    private taskTypesService: services.TaskTypesService
  ) { }

  ngOnInit(): void {
    this.load();
  }

  async load() {
    this.templatedTaskItems = await this.taskTypesService.loadTaskTypes();
  }

  closedEvent(event: any) {
    if(JSON.stringify(this.selected) != JSON.stringify(event)){
      this.selected = event;
      this.onClosed.emit(event);
    }
  }
}
